export default __webpack_public_path__ + "static/media/USB-disconnected.191a8873.svg";